import { render } from "./SortActions.vue?vue&type=template&id=2f8c6e71&scoped=true"
import script from "./SortActions.vue?vue&type=script&lang=js"
export * from "./SortActions.vue?vue&type=script&lang=js"

import "./SortActions.vue?vue&type=style&index=0&id=2f8c6e71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8c6e71"]])

export default __exports__